<template>
  <transition
    name="fade"
    mode="out-in"
    v-bind="$attrs"
    :enter-active-class="activeClasses"
    :leave-active-class="activeClasses"
    :enter-class="enterLeaveClasses"
    :leave-to-class="enterLeaveClasses"
    v-on="$listeners"
    >
    <slot />
  </transition>
</template>

<script>
  export default {
    data: function() {
      return {
        activeClasses: [
          '$motion/transition:opacity:curve:linear',
          '$motion/transition:opacity:duration:250ms',
          '$motion/transition:visibility:curve:linear',
          '$motion/transition:visibility:duration:250ms',
          'motion/transition',
        ].join(' '),
        enterLeaveClasses: [
          'layout/invisible',
        ].join(' ')
      };
    },
  }
</script>
